import { useEffect } from 'react';
import { SiteApi } from '../../api/SiteApi';
import { GoogleAnalytics } from '../../classes/GoogleAnalytics';
import { CommonValidation } from '../common/commonValidation/commonValidation';
import {
    Features,
    setSite,
    setBrandSearchComplete
} from 'state/slices/siteSlice';
import { useAppDispatch } from 'state/hooks';
import { setLanguageSafe } from 'helpers/location';
import { Country } from 'components/common/CommonTypes';

type Brand = {
    brandId: number;
    googleAnalyticsTrackingId: string;
    brandStyles: string;
};

type SiteSettings = {
    brand: Brand;
    clientId: string;
    domain: string;
    audience: string;
    features: Features;
    language: string;
    country: Country;
    showBankDetails: boolean;
    showRepairAddress: boolean;
};

function useSiteInitializer() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const controller = new AbortController();

        const getSiteSettings = () => {
            const successCallback = (foundSettings: SiteSettings) => {
                const {
                    brand: {
                        brandId,
                        brandStyles,
                        googleAnalyticsTrackingId: trackingId
                    },
                    ...siteSettings
                } = foundSettings;

                if (CommonValidation.isNotEmpty(trackingId)) {
                    GoogleAnalytics.initialise(trackingId);
                }

                setLanguageSafe(siteSettings.language);
                localStorage.setItem('country', foundSettings.country);

                dispatch(
                    setSite({
                        ...siteSettings,
                        brandId,
                        brandStyles,
                        brandSearchComplete: true,
                        showRepairAddress:
                            siteSettings.showRepairAddress ?? true
                    })
                );
            };

            const failureCallback = () => {
                console.log('Failed to find brand');
                dispatch(setBrandSearchComplete(true));
            };

            const currentCountry = localStorage.getItem('country');

            new SiteApi().getSiteSettings(
                globalThis.location.hostname,
                globalThis.location.pathname.split('/')[1],
                currentCountry,
                successCallback,
                failureCallback,
                controller.signal
            );
        };

        getSiteSettings();

        return () => controller.abort();
    }, [dispatch]);
}

export default useSiteInitializer;
